import React from 'react'
import cn from 'classnames'

export const SlideNav = (props) => 
	<div className="slidenav">
		{props.slides.map( (slide, i) => {
			const slideClass = cn('item', {active: props.current === i})
			return <div className={slideClass} key={i} onClick={props.setSlide.bind(this, i)}/>
		})}
	</div>


// WEBPACK FOOTER //
// ./src/components/SlideNav.js